import get from "lodash/get";

export const getRestartScheduled = state => get(state, "restartNotification.payload.restartScheduled", false);
export const getRestartingAt = state => get(state, "restartNotification.payload.restartingAt");

export const getRestartNotificationFetchSuccess = state => get(state, "restartNotification.fetchSuccess", false);
